<div class="container"
  [style.margin-top]="- (choices.length * 18 / 2) + 'px'">
  <div class="choice"
    *ngFor="let choice of choices; let c = index">
    <div class="display" [style.display]="(visibleChoice === c) ? 'inline-block' : 'none'">
      {{ choice }}
    </div>
    <div class="bullet-container">
      <div class="bullet"
        (mouseover)="visibleChoice = c"
        (mouseout)="visibleChoice = -1"
        [ngClass]="(c === selected) ? 'selected' : ''"
        (click)="doSelect(c)">
      </div>
    </div>
  </div>
</div>
